module.exports = __webpack_public_path__ + "static/media/finnovex.ff4c42f3.png";